import React, { JSX } from 'react';
import ActionButton from '../r2/ActionButton';
import { ItemValue } from 'components/types/ListItem';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type ActionButtonItem = {
  id: string;
  fields: {
    BaseLink: {
      value: {
        text: string;
        href: string;
        target: string;
      };
    };
    BaseSvg: {
      value: string;
    };
    BasePhoneNumber: Field<string>;
  };
};

type ActionButtonGroupProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    BaseBackgroundColor: ItemValue;
    list: Array<ActionButtonItem>;
  };
};

const ActionButtonGroup = (props: ActionButtonGroupProps): JSX.Element => {
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const { fields } = props;

  return (
    <>
      <div
        className={classNames('overhauled', marginSize)}
        id={`action-btn-group-${props.rendering?.uid}`}
      >
        <div
          className={`${
            fields?.BaseBackgroundColor?.name
              ? fields?.BaseBackgroundColor?.name
              : 'bg-container'
          }`}
        >
          <div className="jss-inner-container">
            <div className="action-btn-group">
              {fields?.list?.map(({ id, fields }) => {
                return (
                  <ActionButton
                    key={id}
                    isLinkExternal={fields?.BaseLink?.value?.target || ''}
                    icon={fields?.BaseSvg?.value || ''}
                    link={fields?.BaseLink?.value?.href || '#'}
                    label={fields?.BaseLink?.value?.text || ''}
                    phone={fields?.BasePhoneNumber?.value}
                    additionalClasses={fields?.BaseSvg?.value || ''}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActionButtonGroup;
